"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOnlineFile = getOnlineFile;
var _request = _interopRequireDefault(require("@/utils/request"));
/**
 *获取对应文件的路径
 *
 */
function getOnlineFile(obj) {
  return (0, _request.default)({
    url: '/equery/ecmFunctionSet/getByCodeList',
    method: 'post',
    data: obj
  });
}